<template>
  <section>
    <PageTitle title="New Reservation" v-bind:crumbs="[
        {href:'/home',title:'Home'},
        {href:'/reservations',title:'All Reservations'},
        {href:'/new_reservation',title:'Add New Reservations'}
        ]" />
    <div class="wrapper wrapper-content animated fadeInRight padding-10"  style="padding-bottom: 0px !important;">
      <div class="ibox-title">
        <div class="wrapper wrapper-content" style="padding-top: 0;">
        <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
        <div class="sk-bounce1"></div>
        <div class="sk-bounce2"></div>
        <div class="sk-bounce3"></div>
      </div>
      <ResturantBranches ref="ResturantBranches" v-bind:selectedBranch="selectedBranch" :not-fetch-menu="true" />
    </div>
      </div>
        <form @submit.prevent="addNewReservation">
          <div class="row">
            <div class="col-md-6 form-group">
              <div class="ibox-content m-t-sm height-525">
                <h2>Customer Details</h2>
                <div class="form-group">
                  <div class="input-group m-b">
                    <input type="text" v-model="existingCustomerNumber" id="contactNumber1" class="form-control" placeholder="Search For Existing Customer By Number" title="Please enter a valid phone number"/>
                    <span class="input-group-btn"><button v-on:click="checkForExistingCustomer()" type="button" class="btn btn-primary"><i class="fa fa-search"></i></button></span>
                  </div>
                </div>
                <div class="form-group">
                  <label>Full Name</label>
                  <input required="required" v-model="customer.name" type="text" class="form-control" :readonly="makeCustomerReadonly" placeholder="Full Name...">
                </div>
                <div class="form-group">
                  <label>Contact 1</label>
                  <input v-model="customer.contact1" required="required" :readonly="makeContact1Readonly" type="text" class="form-control"  placeholder="Contact 1...">
                </div>
                <div class="form-group">
                  <label>Contact 2</label>
                  <input v-model="customer.contact2" type="text" class="form-control" :readonly="makeCustomerReadonly"  placeholder="Contact 2..."  pattern="^(0|\+)[1-9]*[0-9]{3,}$" title="Please enter a valid phone number">
                </div>
                <div class="form-group">
                  <label>Contact 3</label>
                  <input v-model="customer.contact3" type="text" class="form-control" :readonly="makeCustomerReadonly" placeholder="Contact 3..."  pattern="^(0|\+)[1-9]*[0-9]{3,}$" title="Please enter a valid phone number">
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <input v-model="customer.email" type="email" class="form-control" :readonly="makeCustomerReadonly" placeholder="Email...">
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="ibox-content m-t-sm height-525">
                <h2>Reservation Details</h2>
                <div class="form-group">
                  <label for="date">Date</label>
                  <input type="date" required="required" class="form-control date_picker" v-model = "date" id="date" aria-describedby="emailHelp" placeholder="Set Date">
                </div>
                <div class="form-group">
                  <label for="time">Time</label>
                  <input type="time" required="required" class="form-control" v-model="time" id="time" placeholder="Set Time">
                </div>
                <div class="form-group">
                  <label for="person-count">Number of person</label>
                  <input type="number" required="required" min="1" max="999" class="form-control" v-model="personCount" id="person-count" placeholder="Enter Number of Person to Reserve">
                </div>
                <div class="form-group">
                  <label for="special-request">Special Request</label>
                  <textarea type="text" class="form-control custom-textarea" v-model="specialRequest" id="special-request" maxlength="254" placeholder="Enter Any Special Request" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary width-40" :disabled="disableAddReservationBtn">Add New Reservation</button>
          </div>
        </form>
      </div>
  </section>
</template>

<script>
import PageTitle from "@/components/layout_components/PageTitle.vue";
import ResturantBranches from "@/components/pos/ResturantBranches.vue";
import Multiselect from "vue-multiselect";
import SearchCustomerByNameAndContactNumber from "@/components/utils/SearchCustomerByNameAndContactNumber.vue";
import moment from "moment/moment";
import {addVoidItem} from "@/api/voidItems";
import {addNewReservations} from "@/api/reservations";

export default {
  name: "NewReservation",
  components: {SearchCustomerByNameAndContactNumber, Multiselect, ResturantBranches, PageTitle},
  data () {
    return {
      selectedBranch: [],
      isHideSpinner: "hide",
      date : '',
      time : '',
      existingCustomerNumber: '',
      specialRequest : '',
      makeContact1Readonly: false,
      makeCustomerReadonly: false,
      disableAddReservationBtn : false,
      personCount : 1,
      customer: {
        "id": 0,
        "name": "",
        "contact1": null,
        "contact2": null,
        "contact3": null,
        "email": "",
        "blockReasons" : "",
        "customerStatus": "active",
        customerAddressesById: [{
          address:"",
          areasByAreaId:{},
          "customersByCustomerId": {
            "id": 0,
          },
          deleted: false
        }]
      },
    }
  },
  mounted: function () {
    var today = new Date().toISOString().split('T')[0];
    $('#date').attr('min', today);

    // Set max date to 3 months from now
    var maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);
    var maxDateString = maxDate.toISOString().split('T')[0];
    $('#date').attr('max', maxDateString);
  },
  methods: {

    backToAllReservation () {
      this.$router.push({ name: 'Reservations' });
    },
    async addNewReservation() {
      this.disableAddReservationBtn = true
      if (this.selectedBranch.length === 0) {
        swal("Warning!", "Make sure branch is selected!", "warning")
        return
      }
      const reservation = {
        "id": 0,
        "restaurant": {
          "id": this.selectedBranch.restaurantsByRestaurantId.id,
        },
        "branch": {
          "id": this.selectedBranch.id,
        },
        "customer": {
          "id": this.customer.id,
          "name": this.customer.name,
          "contact1": this.customer.contact1,
          "contact2": this.customer.contact2,
          "contact3": this.customer.contact3,
          "email": this.customer.email,
          "customerStatus": "active",
          "customerAddressesById": [
            {
              "address": "Dummy",
              "areasByAreaId": {
                "id": this.$store.state.takeAwayAddressId
              }
            }
          ]
        },
        "specialRequest": this.specialRequest,
        "totalPersons": Number(this.personCount),
        "reservationDate": this.date + 'T' + this.time,
      }
      await addNewReservations(reservation);
      swal("SUCCESS!", "Reservation has been created successfully!", "success");
      this.disableAddReservationBtn = false
      this.reset()
      this.resetBranchFilter()
      this.resetReservationForm()
      this.$router.push({ name: 'Reservations' });
    },

    checkForExistingCustomer: async function () {
      var isValidContactNumber = new RegExp('^([0+])[1-9][0-9]{9}$')
      if(!isValidContactNumber.test($("#contactNumber1").val())) {
        console.log('here')
        swal("TRY AGAIN", "Invalid Phone Number", "error");
        return
      }
      let params = new URLSearchParams();
      params.append("contact_number", this.existingCustomerNumber);
      let existingCustomer = await this.$http.post(this.$store.state.mainAppURL + "customers/find_customer_from_contact", params);
      // console.log(existingCustomer.data);
      if(existingCustomer.data !== "" && existingCustomer.data !== null){
        this.customer = existingCustomer.data
        this.makeContact1Readonly = true
        this.makeCustomerReadonly = true
      } else{
        let existingCustomerNumber = this.existingCustomerNumber
        this.reset()
        this.makeContact1Readonly = true
        this.customer.contact1 = existingCustomerNumber
        swal("Info!","Customer with this number does not exist. Kindly enter the customer details.", "info");
      }
    },

    reset() {
      this.customer.id = 0
      this.customer.name = ''
      this.customer.contact1 = ''
      this.customer.contact2 = ''
      this.customer.contact3 = ''
      this.customer.email = ''
      this.customer.blockReasons = ''
      this.customer.customerStatus = 'active'
      this.customer.deleted = 'active'
      this.makeContact1Readonly = false
      this.makeCustomerReadonly = false
      this.existingCustomerNumber = ''
    },

    resetBranchFilter() {
      this.selectedBranch = []
      this.$refs.ResturantBranches.selectedRestaurant = ''
      this.$refs.ResturantBranches.selectedBranch = ''
    },

    resetReservationForm() {
      this.date = ''
      this.time = ''
      this.personCount = 1
      this.specialRequest = ''
    }
  }
}
</script>

<style scoped>
.height-525 {
  height: 525px;
}

.width-40 {
  width: 40rem;
}

.padding-10 {
  padding-top: 10px;
}

.wrapper-content{
  padding-bottom: 0;
}

.custom-textarea {
  width: 100% !important;
  min-height: 175px;
  resize: vertical;
}
</style>